import { render, staticRenderFns } from "./EducationalGroupAttendanceDelete.vue?vue&type=template&id=8e6a4166&"
import script from "./EducationalGroupAttendanceDelete.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupAttendanceDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports